import React, { useState } from 'react';
import Content from '../components/Layout/Content';
import Box from '@mui/material/Box';
import { BreadcrumbComponent } from '../components/BreadcrumbComponent/BreadcrumbComponent';
import { STORAGE_KEYS } from '../shared/constants';
import SessionService from '../services/SessionService';
import '../assests/css/style.css';

import {
  FIND_CARE,
  FIND_CARE_RECENT_LOCATIONS as RecentLocations,
  FIND_CARE_TOP_LOCALITIES as TopLocalities,
  FIND_CARE_BREADCRUMBDATA as breadcrumbData,
} from '../shared/Strings';
import { FindCareModule } from '@premkumarmph/find-care';

const BASE_URL = process.env.REACT_APP_API_HOST;
const API_PATH = process.env.REACT_APP_API_PATH;

const COMPLETE_URL = BASE_URL + API_PATH;

export const FindCare = () => {
  const token = SessionService.getItem(STORAGE_KEYS.AUTH_TOKEN);
  sessionStorage.setItem("FROM_ENTERPRISE",true);
  sessionStorage.setItem("FINDCARE_URL",COMPLETE_URL);
  return (
    <Content>
      {/* <BreadcrumbComponent
        breadcrumbData={breadcrumbData}></BreadcrumbComponent> */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          width: { xs: '100%', sm: '100%' },
        }}>
        <FindCareModule
          token={token}
          URL={COMPLETE_URL}
          path="/care/findCare"
          hidePartnerList={true}
          hideInNetwork={true}
          fromEnterprise={true}
        />
      </Box>
    </Content>
  );
};
